<template>
    <div class="overline">
        <slot />
    </div>
</template>

<script>
export default {
  name: 'CardOverline'
};
</script>
